import {
    all, put, select, take, takeLatest,
} from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'connected-react-router';

import {
    getPathnameSelector,
    getSearchSelector,
} from '../selectors/RouterSelector';
import {
    getAccessTokenSelector,
    getUserIdSelector,
    getOrgaIdSelector,
} from '../reduxModules/Authentication';
import {
    REQUEST_GET_ME_ERROR,
    REQUEST_GET_ME_SUCCESS,
    getMe,
} from '../reduxModules/APIMe';

export function* callAction() {
    if (env.NODE_ENV !== 'production') return;
    let userId = yield select(getUserIdSelector);
    const [
        pathname,
        search,
    ] = yield all([
        select(getPathnameSelector),
        select(getSearchSelector),
    ]);
    // If the user id is not found, try to load it
    if (!userId) {
        const accessToken = yield select(getAccessTokenSelector);
        if (accessToken) {
            yield put(getMe());
            yield take([
                REQUEST_GET_ME_SUCCESS,
                REQUEST_GET_ME_ERROR,
            ]);
            userId = yield select(getUserIdSelector);
        }
    }
    const orgaId = yield select(getOrgaIdSelector);
    const gtmEvent = {
        event: 'VirtualPageview',
        virtualPageURL: `${pathname}${search}`,
        virtualPageTitle: document.title,
        userId: userId || undefined,
        orgaId: orgaId || undefined,
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(gtmEvent);
}

export function* watch() {
    yield takeLatest([
        LOCATION_CHANGE,
    ], callAction);
}
